import { PraiseBadge } from '@ms/yammer-graphql';

import {
  PublishersOpenTeamsMeetingNewQuestionAction,
  PublishersOpenTeamsMeetingNewUpdateAction,
} from '../../domains/publishers/actions.types';

import {
  Publisher,
  PublisherPostType,
  Publishers,
  TeamsMeetingNewQuestionPublisher,
  TeamsMeetingNewUpdatePublisher,
} from './types';

const createTeamsMeetingThreadStarterPublisher = (id: Publisher['id']) => ({
  attachments: [],
  hasAttemptedToAttachFile: false,
  badge: PraiseBadge.THUMBSUP,
  changedGroupWhileFilesAttached: false,
  changedPostOnBehalfOfUserWhileFilesAttached: false,
  id,
  isAnnouncement: false,
  isAnonymousMessage: false,
  isExpanded: true,
  isGifPickerOpen: false,
  isLinkModalOpen: false,
  isTopicBarOpen: false,
  notifiedUserIds: [],
  praisedUserIds: [],
  pollOptions: [],
  topicNames: [],
  topicIds: [],
});

type OpenTeamsMeetingPublisher = (
  state: Publishers,
  payload: PublishersOpenTeamsMeetingNewUpdateAction['payload'] | PublishersOpenTeamsMeetingNewQuestionAction['payload']
) => Publishers;

const openTeamsMeetingNewUpdatePublisher: OpenTeamsMeetingPublisher = (
  state,
  { id, teamsMeetingId, publisherInstanceId }
) => {
  const publisher: TeamsMeetingNewUpdatePublisher = {
    ...createTeamsMeetingThreadStarterPublisher(id),
    ...state[id],
    publisherInstanceId,
    teamsMeetingId,
    postType: PublisherPostType.TeamsMeetingNewUpdate,
    isMandatoryNotification: false,
  };

  return {
    ...state,
    [id]: publisher,
  };
};

const openTeamsMeetingNewQuestionPublisher: OpenTeamsMeetingPublisher = (
  state,
  { id, teamsMeetingId, publisherInstanceId }
): Publishers => {
  const publisher: TeamsMeetingNewQuestionPublisher = {
    ...createTeamsMeetingThreadStarterPublisher(id),
    ...state[id],
    isExpanded: true,
    publisherInstanceId,
    teamsMeetingId,
    postType: PublisherPostType.TeamsMeetingNewQuestion,
  };

  return {
    ...state,
    [id]: publisher,
  };
};

export { openTeamsMeetingNewQuestionPublisher, openTeamsMeetingNewUpdatePublisher };
